import processCalcTotalsRebuildReasonAppliedAdjsHarness from './processCalcTotalsRebuildReasonAppliedAdjsHarness.js'
import createAdjDetailHarness from '../helpers/createAdjDetailHarness.js'
import getSkillOptAdjReasons from '../helpers/getSkillOptAdjReasons.js'
//-----------------------------
// process apply new rune adjs
//-----------------------------
export default function processApplyNewRuneAdjs({ rune, character }) {
  console.log('--------------------------')
  console.log('IN processApplyNewRuneAdjs rune = ', window.$deepCopy(rune))
  //-----------------------
  // defensive check parms
  //-----------------------
  if (!rune || !character) {
    console.error('processApplyNewRuneAdjs: missing required parms')
    return { rune, character }
  }
  /*
  NOTES:
  ------
  Summary: From character-rune adjs > load into character skills, characteristics & abilities.

  - The following adjs arrays are typically downloaded from the db during initial character load with existing runes.
  - FOR NEW RUNES this info needs to be added to the character object from the rune adjs already loaded 
    for new rune, whilst waiting for the rune to be committed to the db:

      A. skills.integrated_rune_skill_adjs
      B. characteristics.integrated_rune_characteristic_adjs
      C. runes.ability_adjs

  Example downloaded data for rune "My Mega Rune/Motion Rune":
  ------------------------------------------------------------

  "skills": [
      {
          "id": "67ade412-70d3-4cca-bc54-fbe9653534ff",
          "name": "Athletics",
          "category": "Core",
          "type": "Common",
          "default": "True",
          "tickable": "True",
          "formula": "Str+Dex",
          "formula_arg1": "str",
          "formula_arg2": "dex",
          "formula_arg3": null,
          "formula_oper1": "+",
          "formula_oper2": null,
          "integrated_rune_skill_adjs": [
              {
                  "id": 10,
                  "rune_name": "My Mega Rune",
                  "name": "Athletics",
                  "adj_value": 5
              }
          ],

  "characteristics": [
      {
          "id": "c6986965-42c8-4683-908d-fc4a77e0014c",
          "character_name": "Bert",
          "name": "str",
          "rolled": 10,
          "cur": 11,
          "improvs_tot": 0,
          "incr_percent": 51,
          "integs_tot": 0,
          "adjs_tot": 1,
          "characteristic_adjs": [],
          "integrated_rune_characteristic_adjs": [
              {
                  "id": 8,
                  "rune_name": "My Mega Rune",
                  "name": "str",
                  "adj_value": 1
              }
          ]

  "runes": [
      {
          "id": "ebdc7277-7165-44e0-9374-51b74a50204c",
          "spells": [],
          "skill_adjs": [],
          "ability_adjs": [
              {
                  "id": 4,
                  "rune_name": "Motion Rune",
                  "name": "move",
                  "label": "Movement",
                  "adj_value": 1
              }
          ],
  */
  //=======================================================================================
  // A. load skill adjs e.g. +5 Stealth from Shadow Rune [RuneSkillAdjs]
  //---------------------------------------------------------------------
  // FROM: rune.skill_adjs
  // TO: SKILLS[n].integrated_rune_skill_adjs - for matching skill
  //------------------------------------------------------------
  console.log('1a. rune.skill_adjs = ', window.$deepCopy(rune.skill_adjs))
  console.log('1b.character = ', window.$deepCopy(character))
  console.log('1c.character.skills = ', window.$deepCopy(character.skills))
  console.log('1d.character.skill_adjs = ', window.$deepCopy(character.skill_adjs))

  function _getCharacterItem(id) {
    const character_item = character.items.find((i) => i.id === id)
    if (!character_item) {
      console.warn('processApplyNewRuneAdjs could not find matching character item for id = ', id)
      return null
    }
    // Normalise to the CharacterItem id so that all
    // downstream adj detail entries use a consistent
    // id-based character_item field. UI layers that
    // need the name can resolve it via this id.
    return character_item.id
  }
  //----------
  // declares
  //----------
  let matching_adjs = []
  //----------------------
  // loop rune skill adjs
  //----------------------
  console.log('==================================================================')
  console.log('========== OUTER LOOP - each adj in rune.skill_adjs ==========')
  console.log('==================================================================')
  rune.skill_adjs.forEach((adj) => {
    console.log('-----------------------------------------------------------------------')
    console.log('2. this rune skill adjs loop - processing adj = ', adj)
    console.log('adj.name = ', adj.name)
    console.log('adj.rune_name = ', adj.rune_name)
    //--------------------------------------------------------------
    // set character item in adj if newly added rune linked to item
    //--------------------------------------------------------------
    console.log('rune.skill_adjs adj.character_item = ', adj.character_item)
    console.log('rune.skill_adjs rune.character_item = ', rune.character_item)
    if (adj.character_item == null && rune.character_item) {
      console.log('getting character item for adj from rune.character_item = ', rune.character_item)
      adj.character_item = _getCharacterItem(rune.character_item)
    }
    //-------------------------------------------------
    // get matching skills based on adj type and props
    //-------------------------------------------------
    let matching_skills = []
    console.log('2a. need to find matching skills for this adj')
    //---------------------------------------------------------------------------------------------------------
    // A. runecasting: match specific rune by display_name (runecasting skill only for integrated/active rune)
    //---------------------------------------------------------------------------------------------------------
    if (adj.name === 'Runecasting') {
      console.log(
        '2b. processing runecasting skill matching by display_name = adj.rune_name = ',
        adj.rune_name,
        ' ',
      )
      matching_skills = character.skills.filter((s) => {
        const matchesRuneName = s.display_name === adj.rune_name
        if (!matchesRuneName) {
          return false
        }
        //--------------------------------------------
        // only match where associated rune is active
        //--------------------------------------------
        const active_rune =
          character.runes && character.runes.length > 0
            ? character.runes.find((r) => r.name === s.display_name && r.active === true)
            : null
        return !!active_rune
      })
      //--------------------------------------------------------------------------------------------------------------------
      // B. default: match by name (covers both 'normal' skills [should only get only] & runecasting with all_in_type=true)
      //--------------------------------------------------------------------------------------------------------------------
    } else {
      console.log('2c. processing default matching by name = ', adj.name)
      matching_skills = character.skills.filter((s) => s.name === adj.name)
    }
    console.log('3. found matching skills = ', window.$deepCopy(matching_skills))
    console.log('3a. found matching skills count = ', window.$deepCopy(matching_skills.length))
    //-------------------------------------------------
    // found matching skills - need to add adj to each
    //-------------------------------------------------
    if (matching_skills && matching_skills.length > 0) {
      console.log('3b. found matching skills count = ', matching_skills.length)
      //----------------------
      // loop matching skills
      //----------------------
      console.log('==================================================================')
      console.log('=============== INNER LOOP - each matching skill =================')
      console.log('==================================================================')
      matching_skills.forEach((s) => {
        console.log('-----------------------------------------------------------------------')
        console.log('4. this inner loop - character has this skill = ', window.$deepCopy(s))
        //-------------------------------------------------------------
        // create adj array if missing (e.g. new character w/no runes)
        //-------------------------------------------------------------
        if (!s.integrated_rune_skill_adjs) {
          console.log('4b. creating missing integrated_rune_skill_adjs array')
          s.integrated_rune_skill_adjs = []
        }
        console.log(
          '4c. current integrated_rune_skill_adjs = ',
          window.$deepCopy(s.integrated_rune_skill_adjs),
        )
        //---------------------------------------
        // add skill adj to integrated rune adjs
        //---------------------------------------
        console.log(
          '5. pushing this adj to skill integrated_rune_skill_adjs = ',
          window.$deepCopy(adj),
        )
        s.integrated_rune_skill_adjs.push(adj)
        console.log('6. updated skill integrated_rune_skill_adjs = ', window.$deepCopy(s))
      })
      console.log('====================================')
      console.log('========== END INNER LOOP ==========')
      console.log('====================================')
      console.log('6b. off to create adj detail entry')
      //-----------------------------------------------------------------
      // ensure integrated rune skill adj has a rich adj_reason so that
      // both the detailed entry and headline reasons use display_name
      // where provided (e.g. "Air Rune (Jump)"). This mirrors
      // loadSpecificSkillAdjs behaviour on initial load.
      //-----------------------------------------------------------------
      if (!adj.adj_reason) {
        const baseName = adj.rune_name && adj.rune_name !== '' ? adj.rune_name : adj.name
        if (adj.name === 'Runecasting' && baseName !== '') {
          adj.adj_reason = baseName
        } else if (adj.display_name && adj.display_name !== '') {
          adj.adj_reason = `${baseName} (${adj.display_name})`
        } else {
          adj.adj_reason = baseName
        }
      }
      //--------------------------------------------------------------------
      // create adj detail entry (one per adj regardless of skills matched)
      //--------------------------------------------------------------------
      const adj_entry = createAdjDetailHarness({
        adj,
        adjs: character.skill_adjs,
        source: 'integrated_rune',
        character,
      })
      //---------------------------------------
      // add adj entry to character skill adjs
      //---------------------------------------
      if (adj_entry) {
        character.skill_adjs.push(adj_entry)
        console.log('7. created adj detail entry = ', window.$deepCopy(adj_entry))
      }
      //--------------------------------
      // add adj entry to matching_adjs
      //--------------------------------
      matching_adjs.push(adj)
      //------------------------------
      // where no skills matching adj
      //------------------------------
    } else {
      console.log('3c. no matching skills found for adj = ', adj.name)
    }
    console.log('====================================')
    console.log('========== NEXT OUTER LOOP =========')
    console.log('====================================')
  })
  console.log('5b. after skill adjs outer loop')
  //=======================================================================================
  // A2. process calc to all skill adjs
  //------------------------------------
  if (rune.skill_adjs && rune.skill_adjs.length > 0) {
    console.log(
      '5c. off to processCalcTotalsRebuildReasonAppliedAdjsHarness matching_adjs = ',
      matching_adjs,
    )
    character = processCalcTotalsRebuildReasonAppliedAdjsHarness({
      adjs: matching_adjs,
      category: 'skill',
      character,
    })

    //------------------------------------------------------------------
    // A3. update optional skill adj counts & reasons for affected skills
    //------------------------------------------------------------------
    if (matching_adjs && matching_adjs.length > 0) {
      // de-duplicate by adj.name (skill name/type)
      const affectedTypes = [...new Set(matching_adjs.map((a) => a.name))]

      affectedTypes.forEach((type) => {
        // consider all OPTIONAL (applied === false) adjs for this skill name,
        // across all sources (character, characteristic, integrated_rune)
        const skillOptAdjs = (character.skill_adjs || []).filter(
          (adj) => adj.name === type && adj.applied === false,
        )

        const adjs_cnt_opt = skillOptAdjs.length
        if (adjs_cnt_opt === 0) {
          return
        }

        // build optional reasons string reusing existing helper logic
        const reasons = getSkillOptAdjReasons({ adjs: skillOptAdjs, type })

        // update all matching skills (by name) with count & reasons
        const matchingSkills = (character.skills || []).filter((s) => s.name === type)
        matchingSkills.forEach((skill) => {
          skill.adjs_cnt_opt = adjs_cnt_opt
          skill.adjs_reasons_character_skill_opt = reasons
        })
      })
    }
  }
  //=======================================================================================
  // B. load rune characteristic adjs e.g. Earth +1 STR
  //----------------------------------------------------
  // FROM: rune.characteristics_adjs
  // TO: CHARACTERISTICS[n].integrated_rune_characteristic_adjs - for matching characteristic
  //---------------------------------------------------------------------------------------
  console.log('2222. rune.characteristics_adjs = ', rune.characteristics_adjs)
  rune.characteristics_adjs.forEach((adj) => {
    console.log('2222.1 processing adj = ', adj)
    console.log('character.characteristics = ', character.characteristics)
    //--------------------------------------------------------------
    // set character item in adj if newly added rune linked to item
    //--------------------------------------------------------------
    console.log('rune.characteristics_adjs adj.character_item = ', adj.character_item)
    console.log('rune.characteristics_adjs rune.character_item = ', rune.character_item)
    if (adj.character_item == null && rune.character_item) {
      console.log('getting character item for adj from rune.character_item = ', rune.character_item)
      adj.character_item = _getCharacterItem(rune.character_item)
    }
    //--------------------------
    // get characteristic index
    //--------------------------
    const idx = character.characteristics.findIndex((s) => s.name === adj.name)
    console.log('2222 idx = ', idx)
    //-------------------------------
    // found matching characteristic
    //-------------------------------
    if (idx !== -1) {
      console.log('2222 found characteristic = ', idx)
      //-------------------------------------------------------------
      // create adj array if missing (e.g. new character w/no runes)
      //-------------------------------------------------------------
      if (!character.characteristics[idx].integrated_rune_characteristic_adjs) {
        character.characteristics[idx].integrated_rune_characteristic_adjs = []
      }
      //-----------------------------------------------
      // ref integrated rune characteristic adjs array
      //-----------------------------------------------
      const rune_adjs = character.characteristics[idx].integrated_rune_characteristic_adjs
      //-------------------------------------------------
      // add adj to any existing adjs for characteristic
      //-------------------------------------------------
      rune_adjs.push(adj)
      //-------------------------
      // create adj detail entry
      //-------------------------
      const adj_entry = createAdjDetailHarness({
        adj,
        adjs: character.characteristic_adjs,
        source: 'integrated_rune',
        character,
      })
      //---------------
      // add adj entry
      //---------------
      if (adj_entry) {
        character.characteristic_adjs.push(adj_entry)
        console.log('B. created adj detail entry = ', window.$deepCopy(adj_entry))
      } else {
        console.error(
          'B. processApplyNewRuneAdjs: failed to create characteristic adj entry for adj = ',
          adj,
        )
      }
    }
  })
  //=======================================================================================
  // B2. process save all characteristic adjs
  //------------------------------------------
  console.log('B2. rune.characteristics_adjs = ', rune.characteristics_adjs)
  if (rune.characteristics_adjs && rune.characteristics_adjs.length > 0) {
    character = processCalcTotalsRebuildReasonAppliedAdjsHarness({
      adjs: rune.characteristics_adjs,
      category: 'characteristic',
      character,
    })
  }
  //=======================================================================================
  // C. load ability adjs e.g. +1 melee damage
  //-------------------------------------------
  // ability adjs not moved to an array (are specific props on character)
  //---------------------------------------------------------------------------------------
  console.log('3333. rune.ability_adjs = ', rune.ability_adjs)
  rune.ability_adjs.forEach((adj) => {
    console.log('3333.1 processing adj = ', adj)
    //--------------------------------------------------------------
    // set character item in adj if newly added rune linked to item
    //--------------------------------------------------------------
    console.log('rune.ability_adjs adj.character_item = ', adj.character_item)
    console.log('rune.ability_adjs rune.character_item = ', rune.character_item)
    if (adj.character_item == null && rune.character_item) {
      console.log('getting character item for adj from rune.character_item = ', rune.character_item)
      adj.character_item = _getCharacterItem(rune.character_item)
    }
    //-------------------------
    // create adj detail entry
    //-------------------------
    const adj_entry = createAdjDetailHarness({
      adj,
      adjs: character.ability_adjs,
      source: 'integrated_rune',
      character,
    })
    //---------------
    // add adj entry
    //---------------
    if (adj_entry) {
      character.ability_adjs.push(adj_entry)
      console.log('C. created adj detail entry = ', window.$deepCopy(adj_entry))
    } else {
      console.error(
        'C. processApplyNewRuneAdjs: failed to create ability adj entry for adj = ',
        adj,
      )
    }
  })
  //=======================================================================================
  // C2. process save all ability adjs
  //-----------------------------------
  if (rune.ability_adjs && rune.ability_adjs.length > 0) {
    character = processCalcTotalsRebuildReasonAppliedAdjsHarness({
      adjs: rune.ability_adjs,
      category: 'ability',
      character,
    })
  }
  //--------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers)
  //--------------------------------------------------------------
  console.log('processApplyNewRuneAdjs Returning updated character = ', window.$deepCopy(character))
  return character
}
